import { useQuery } from '@tanstack/react-query';

import { ArticleCard } from './ArticleCard';

import { browseQueries } from '@/lib/queries/browse';

/**
 * "From the editorial" — a lifted dark inset row mixing NEW and POPULAR
 * article cards. §3: video-inset background, full video-line-strong border, a
 * 3px oxblood top rule, serif heading. Against stubs the list is empty and the
 * framed empty state renders.
 */
export function EditorialRow() {
  const { data: items = [] } = useQuery(browseQueries.editorialRow());

  return (
    <section className="border border-t-[3px] border-video-line-strong border-t-oxblood-browse bg-video-inset p-6">
      <h2 className="font-serif text-xl text-video-text">From the editorial</h2>
      {items.length === 0 ? (
        <p className="mt-3 font-sans text-sm text-video-text-faint">
          No editorial pieces yet — published articles will surface here.
        </p>
      ) : (
        <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((item) => (
            <ArticleCard key={item.id} item={item} />
          ))}
        </div>
      )}
    </section>
  );
}
